import React from "react";
import {
  EmptyLow,
  HeaderContainer,
  LabelContainer,
  ListContainer,
} from "../DeviceAlarmManagerList/DeviceAlarmManagerList.styles";
import UI from "@mile-meeting/mile-ui";
import { IAlarmChannel } from "apis/meeting-room-complain/alarm-channel";
import DeviceAlarmChannelListItem from "./DeviceAlarmChannelListItem";

export type DeviceAlarmManagerListProps = {
  onHandleDeleteChannel: (mediumId: string, name: string) => Promise<void>;
  channelList: IAlarmChannel[];
};

const DeviceAlarmManagerList: React.FC<DeviceAlarmManagerListProps> = ({ channelList, onHandleDeleteChannel }) => {
  return (
    <ListContainer>
      <HeaderContainer>
        <LabelContainer minWidth={160} maxWidth={200}>
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            슬랙 워크스페이스
          </UI.Typography>
        </LabelContainer>
        <LabelContainer minWidth={200} maxWidth={240}>
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            채널
          </UI.Typography>
        </LabelContainer>
        <LabelContainer
          minWidth={74}
          maxWidth={160}
          style={{
            marginLeft: "auto",
          }}
        >
          <UI.Typography type="label01" color="var(--alias-color-label-normal)">
            관리
          </UI.Typography>
        </LabelContainer>
      </HeaderContainer>
      {channelList.length === 0 && (
        <EmptyLow>
          <UI.Icon name="view" color="var(--alias-color-label-alternative)" size={24} />
          <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
            등록된 채널이 없습니다. 신속한 조치를 위해 슬랙 채널을 추가해 주세요.
          </UI.Typography>
        </EmptyLow>
      )}
      {channelList.map((channel) => (
        <DeviceAlarmChannelListItem
          workspaceName={channel.slackWorkspaceName}
          channelName={channel.slackChannelName}
          onDelete={() => {
            onHandleDeleteChannel(channel.id, channel.slackChannelName);
          }}
        />
      ))}
    </ListContainer>
  );
};

export default React.memo(DeviceAlarmManagerList);
